import { formatUnits } from 'utils/units';
import React from 'react';
import { StakingPool, UserPoolInfo } from 'api/StakingAPI';
import { useTranslation } from 'react-i18next';
import { Typography } from '@dapp/multi-lib/sdaoui/Typography';
import { twMerge } from 'tailwind-merge';
import { shouldHighlightTokenAmount } from 'structure/staking/utils/stakingValueHighlight';

type UserStakedProps = {
  pool: StakingPool;
  userPoolInfo: UserPoolInfo;
};

export function UserStaked({ pool, userPoolInfo }: UserStakedProps) {
  const { t } = useTranslation('common');
  const staked = formatUnits(
    userPoolInfo?.totalStaked || '0',
    pool?.depositTokenDecimals
  );

  const maximumFractionDigits = Number(staked) > 1000 ? 0 : 2;

  return (
    <Typography
      className={twMerge(
        'pt-px text-xs',
        shouldHighlightTokenAmount(userPoolInfo?.totalStaked)
          ? 'text-green'
          : 'text-[#B4BCD0]'
      )}
    >
      {t('tokenAmount', { value: staked, maximumFractionDigits })}
    </Typography>
  );
}
